import { IFilter } from "../interfaces/IFilter";
import { IPartner } from "../interfaces/IPartner";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/prt/back_office/contract_doc", { offset, filter });
};

export const remove = async (id: string) => {
  return httpRequest.del(`/prt/back_office/contract_doc/${id}`);
};

export const update = async (id: string, data: IPartner | any) => {
  return httpRequest.put(`/prt/back_office/contract_doc/${id}`, data);
};

export const create = async (data: IContractDocType) => {
  return httpRequest.post(`/prt/back_office/contract_doc`, data);
};

type IContractDocType = {
  docFile: string | undefined;
  docType: string | undefined;
  docDesc: string | undefined;
  docName: string | undefined;
  partnerId: string | undefined;
};
